import { render } from "./mini-calendar-pager.vue?vue&type=template&id=72379251"
import script from "./mini-calendar-pager.vue?vue&type=script&lang=js"
export * from "./mini-calendar-pager.vue?vue&type=script&lang=js"

import "./mini-calendar-pager.vue?vue&type=style&index=0&id=72379251&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__